// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#ec9b3c","subMenuActiveText":"#ec9b3c","menuBg":"#1a3561","menuHover":"#2d4c7f","subMenuBg":"#425b84","subMenuHover":"#2d4c7f","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 87